import { ProductIdentifier } from 'components/common/types/DirectSalesProductTemplate.types';

export const searchProductByNameOrId = ({
  products,
  searchTerm,
}: {
  products: ProductIdentifier[];
  searchTerm: string;
}): ProductIdentifier[] => {
  const normalizedSearchTerm = searchTerm.toLowerCase();

  return products.filter(
    ({ name, id }) =>
      name.toLowerCase().includes(normalizedSearchTerm) || id.toLowerCase().includes(normalizedSearchTerm),
  );
};
